import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import {
  BulletinReport,
  Export,
  ExportData,
} from '@/domain/entities/BulletinReport'
import router from '@/router'
import Vue from 'vue'
import { BulletinReportPresenter } from '@/app/ui/presenters/BulletinReportPresenter'
import { AuthModule } from './auth'

export interface BulletinState {
  bulletinData: BulletinReport
  exportData: Export
  isLoading: boolean
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'bulletinReport' })
class Bulletins extends VuexModule implements BulletinState {
  public isLoading = true
  public isLoadingExport = true
  public bulletinData = new BulletinReport(true, '')
  public exportData = new Export(true, '')
  public paginationParam = {
    filter: {
      salescode: '',
      position: '',
      filecode: '',
      dealer: '',
      city: '',
      branch: '',
      start: '',
      end: '',
    },
  }
  public paginationParamsExport = {
    filter: {
      salescode: '',
      position: '',
      filecode: '',
      dealer: '',
      city: '',
      branch: '',
      start: '',
      end: '',
    },
  }

  @Action
  public async getBulletinData() {
    this.setLoading(true)
    const presenter = await container.resolve(BulletinReportPresenter)
    presenter
      .loadBulletinReport(this.paginationParam)
      .then((res: BulletinReport) => {
        this.setLoading(false)
        this.setBulletinData(res)
        //  console.log('Bulletin Data', res)
      })
      .catch((error) => {
        console.error('error', error)
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
      })
  }
  @Action
  public async getExportData() {
    this.setLoading(true)
    this.setLoadingExport(true)
    const presenter = await container.resolve(BulletinReportPresenter)
    presenter
      .loadExport(this.paginationParam)
      .then((res: Export) => {
        this.setExportData(res)
        // console.log('export dataaa', res)
      })
      .catch((error) => {
        console.error('error', error)
      })
      .finally(() => {
        this.setLoadingExport(false)
      })
  }

  @Mutation
  private setBulletinData(bulletin: BulletinReport) {
    this.bulletinData = bulletin
  }
  @Mutation
  private setExportData(exp: Export) {
    this.exportData = exp
  }
  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
  @Mutation
  private setLoadingExport(isLoadingExport: boolean) {
    this.isLoadingExport = isLoadingExport
  }
}

export const BulletinReportModule = getModule(Bulletins)
